import { useState } from "react";
import { useSelector } from "react-redux";
import OpenComplaint from "../../../Artifacts/OpenComplaint.svg";
import RegisteredComplaint from "../../../Artifacts/Registered.svg";
import ResolvedComplaint from "../../../Artifacts/Resolved.svg";
import YTD from "../../../Artifacts/ytd.svg";
import MTD from "../../../Artifacts/mtd.svg";
// import { PriKPI } from "../../../Components/KPI/PriKPI.jsx";
import { PriKPI } from "../../../Components/KPI/PriKPI_variant.js";
import { useQuery } from "@tanstack/react-query";
import { TbFilterDown } from "react-icons/tb";
import ComplaintFilter from "../../../Components/Filters/ComplaintFilter.jsx";
import { EsclatedComplaintDetails } from "./EsclatedComplaintDetail.js";
import { complaint_kpi } from "./ApiComplaint";

export const ComplaintKpi = () => {
  const { data, submitted } = useSelector((state) => state.filtersComplaint);
  const [isFormVisible, setFormVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: kpiData } = useQuery({
    queryKey: ["complaint_kpi", submitted],
    queryFn: () => complaint_kpi(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const toggleForm = () => {
    setFormVisible(!isFormVisible);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="flex flex-col gap-2 pt-2">
      {isFormVisible && (
        <ComplaintFilter
          isFormVisible={isFormVisible}
          setFormVisible={setFormVisible}
        />
      )}
      <div className="flex md:gap-2 gap-0 md:flex-row flex-col-reverse ">
        <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 w-full  gap-3">
          <PriKPI
            Image={OpenComplaint}
            Alt={"Total open complaints"}
            ColorDark={"bg-gradient-to-b from-[#3CD0C0] to-[#129BD2]  "}
            Title={"Open Complaints"}
            Value={kpiData?.ttlComplaint || 0}
            Padding={"pl-0 py-2 pr-2"}
            ImageSize={"w-14 h-14"}
          />

          <PriKPI
            Image={RegisteredComplaint}
            Alt={"Complaints registered today"}
            ColorDark={"bg-gradient-to-b from-[#FE875D] to-[#FD4D90]"}
            Title={" Registered Today"}
            Value={kpiData?.ttlRegistered || 0}
            Padding={"pl-0 py-2 pr-2"}
            ImageSize={"w-14 h-14"}
          />
          <PriKPI
            Image={ResolvedComplaint}
            Alt={"Complaints Resolved Today"}
            ColorDark={"bg-gradient-to-b from-[#00E0FE] to-[#0181D1]"}
            Title={" Resolved Today"}
            Value={kpiData?.ttlResolved || 0}
            Padding={"pl-0 py-2 pr-2"}
            ImageSize={"w-14 h-14"}
          />

          <PriKPI
            Image={MTD}
            Alt={"Total Registered MTDs"}
            ColorDark={"bg-gradient-to-b from-[#FFE700] to-[#F9A526]"}
            Title={"Total Registered MTD"}
            Value={kpiData?.ttlMtd || 0}
            Padding={"pl-0 py-2 pr-2"}
            ImageSize={"w-14 h-14"}
          />
          <PriKPI
            Image={YTD}
            Alt={"MTD Complaint Resolved"}
            ColorDark={"bg-gradient-to-b from-[#EF6AE9] to-[#8463FA]"}
            Title={"MTD  Resolved"}
            Value={kpiData?.ttlMcr || 0}
            Padding={"pl-0 py-2 pr-2"}
            ImageSize={"w-14 h-14"}
          />
          <PriKPI
            Image={YTD}
            Alt={"Escalated Open complaint"}
            ColorDark={"bg-gradient-to-b from-[#EF9759] to-[#B1520E]"}
            Title={"Escalated Complaint "}
            Value={kpiData?.esclated_complaint || 0}
            Padding={"pl-0 py-2 pr-2"}
            ImageSize={"w-14 h-14"}
            onclick={openModal}
            handPosition={"right-2 top-[28px]"}
          />
        </section>
        <div
          className="w-full lg:w-[5%] rounded-lg p-2 bg-gradient-to-b from-rose-300 to-orange-200 flex justify-center items-center transition duration-300 ease-in-out transform hover:scale-105 cursor-pointer "
          onClick={toggleForm}
        >
          <button title="Click to Apply Filters">
            <TbFilterDown className="w-7 h-7 text-[#2A5775]" />
          </button>
        </div>
      </div>
      {isModalOpen && (
        <EsclatedComplaintDetails closeModal={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};
